export const loyaltyDiscount = () => {
    const wrapper = document.querySelector(".ly-modal__rules--btns");
    const container = document.querySelector('.ly-modal__container');
    if (!wrapper) return;

    const discountFunction = (target) => {
        const discountCode = target.textContent.trim();
        const discountUrl = `https://${window.location.hostname}/discount/${discountCode}`;

        if (window.rewardWindow && !window.rewardWindow.closed) {
            window.rewardWindow.close();
        }

        window.rewardWindow = window.open(discountUrl, '_blank');

        if (window.rewardWindow) {
            setTimeout(() => {
                window.rewardWindow.close();
            }, 2000);
        }
    }

    document.addEventListener("click", (e) => {
        const target = e.target;
        if (!target.closest('.lion-reward-code__code')) {
            return;
        }
        discountFunction(target);
    })

    const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) { 
            if (mutation.type === 'childList') {
                const currentTierTitle = document.querySelector('.lion-tier-compare__header-cell--current');
                const titleText = currentTierTitle?.childNodes[0]?.textContent.trim();
                const ruleItems = document.querySelectorAll('.lion-rule-item__content');
                const rewardItems = document.querySelectorAll('.lion-reward-item__content');
                const titleSpan = document.querySelector('.ly-home__title--span');

                ruleItems.forEach((item) => {
                    const button = item.querySelector('.lion-action-button');
                    if (button && button.getAttribute('aria-disabled') === 'true') {
                        item.classList.add("lion-disabled-content");
                    }
                });

                rewardItems.forEach((item) => {
                    const button = item.querySelector('.lion-action-button');
                    if (button && button.getAttribute('aria-disabled') === 'true') {
                        item.classList.add('lion-disabled-content');
                    }
                });

                titleSpan.textContent = titleText;

                observer.disconnect();
            }
        }
    });

    observer.observe(container, {
        childList: true,
        subtree: true
    });
};